import * as React from 'react';

import { useTwoPanelSearchExperiment } from 'bundles/search-common/providers/TwoPanelSearchExperimentProvider';
import { CoachStateProvider } from 'bundles/unified-common/providers/CoachStateProvider';
import { TwoPanelChatRouteProvider } from 'bundles/unified-common/providers/TwoPanelChatRouteProvider';

// Lazy-loaded to avoid pulling in CoachChat → SSELink → ApolloLink at module-load
// time, which breaks unrelated test suites that transitively import this provider.
const CoachChatContainer = React.lazy(
  () => import('bundles/search-common/components/experiments/aiSearchOnLohp/CoachChatContainer')
);

function SearchCoachProvider({ children }: React.PropsWithChildren) {
  const isTwoPanelSearchEnabled = useTwoPanelSearchExperiment();

  return (
    <CoachStateProvider coachOpen={isTwoPanelSearchEnabled}>
      {isTwoPanelSearchEnabled ? (
        <TwoPanelChatRouteProvider>{children}</TwoPanelChatRouteProvider>
      ) : (
        <>
          {children}
          <React.Suspense fallback={null}>
            <CoachChatContainer />
          </React.Suspense>
        </>
      )}
    </CoachStateProvider>
  );
}

export default SearchCoachProvider;
